(() => {
  const initNamglory = () => {
    const reveals = document.querySelectorAll('.ng-reveal:not(.is-visible)');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    document.querySelectorAll('.ng-sticky-buy').forEach((bar) => {
      const mainButton = document.querySelector('.product-form__submit');
      if (!mainButton || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }

      const buyObserver = new IntersectionObserver(
        ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      );
      buyObserver.observe(mainButton);
    });
  };

  document.addEventListener('DOMContentLoaded', initNamglory);
  document.addEventListener('shopify:section:load', initNamglory);
})();
